import { useEffect, useState } from 'react'
import { Column } from 'src/shared/components/Semantic/all'
import { Progress } from 'src/shared/components/ui/progress'

const MOCKUP_GENERATION_DURATION_MS = 15000
const PROGRESS_UPDATE_INTERVAL_MS = 100
const PROGRESS_CAP = 95

export const MockupLoadingView = ({ loadingText }: { loadingText: string }) => {
  const [progress, setProgress] = useState(0)

  useEffect(() => {
    const startTime = Date.now()

    const interval = setInterval(() => {
      const elapsed = Date.now() - startTime
      const newProgress = Math.min(
        PROGRESS_CAP,
        (elapsed / MOCKUP_GENERATION_DURATION_MS) * PROGRESS_CAP
      )
      setProgress(newProgress)
    }, PROGRESS_UPDATE_INTERVAL_MS)

    return () => clearInterval(interval)
  }, [])

  return (
    <Column className="flex-1 items-center justify-center gap-4 py-12 bg-white rounded-lg border border-gray-200/80">
      <Column className="items-center gap-3 w-80">
        <Progress value={progress} className="w-full" />
        <p className="text-sm text-muted-foreground">{loadingText}</p>
      </Column>
    </Column>
  )
}
